"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "the-top-left-buttons" };
const vue_basic_ui_1 = require("@xenodrive/vue-basic-ui");
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssMovementNaviationIcons',
    props: {
        "modelValue": {},
        "modelModifiers": {},
    },
    emits: ["update:modelValue"],
    setup(__props) {
        const mode = (0, vue_1.useModel)(__props, "modelValue");
        const permissions = (0, vue_3.inject)('permissions');
        const query = (0, vue_3.computed)(() => {
            const search = new URLSearchParams(location.search);
            return '?' + search.toString();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Radio), {
                    modelValue: mode.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((mode).value = $event)),
                    class: "the-navigation-buttons",
                    style: { "display": "contents" }
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.RadioItem), { value: "movement_map" }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                                    icon: "fa:map",
                                    "icon-position": "top"
                                }, {
                                    default: (0, vue_2.withCtx)(() => _cache[1] || (_cache[1] = [
                                        (0, vue_2.createTextVNode)("動態表示", -1)
                                    ])),
                                    _: 1,
                                    __: [1]
                                })
                            ]),
                            _: 1
                        }),
                        ((0, vue_2.unref)(permissions)['movement.addressSearch'])
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_basic_ui_1.RadioItem), {
                                key: 0,
                                value: "address_search"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                                        icon: "fa:search",
                                        "icon-position": "top"
                                    }, {
                                        default: (0, vue_2.withCtx)(() => _cache[2] || (_cache[2] = [
                                            (0, vue_2.createTextVNode)("住所検索", -1)
                                        ])),
                                        _: 1,
                                        __: [2]
                                    })
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.RadioItem), { value: "movement_locus" }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                                    icon: "fa:chart-line",
                                    "icon-position": "top"
                                }, {
                                    default: (0, vue_2.withCtx)(() => _cache[3] || (_cache[3] = [
                                        (0, vue_2.createTextVNode)("走行軌跡", -1)
                                    ])),
                                    _: 1,
                                    __: [3]
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                (0, vue_2.renderSlot)(_ctx.$slots, "default")
            ]));
        };
    }
});
